export const fontConstants = {

    FETCH_FONTDETAILS_REQUEST: 'FETCH_FONTDETAILS_REQUEST',
    FETCH_FONTDETAILS_SUCCESS: 'FETCH_FONTDETAILS_SUCCESS',
    FETCH_FONTDETAILS_FAILURE: 'FETCH_FONTDETAILS_FAILURE',
    UPDATE_FONTDETAILS_FROM_SOCKET: 'UPDATE_FONTDETAILS_FROM_SOCKET',

}
